import React, { createContext, useState, useContext, useEffect } from 'react';
import enDict from '../locales/en.json';
import frDict from '../locales/fr.json';
import { normalizeLanguage, isFrenchLanguage } from '../utils/carrierResolver';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

const escapeRegExp = (value) =>
  String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState('en');

  useEffect(() => {
    const saved = localStorage.getItem('togee_language');
    if (saved) {
      setLanguageState(normalizeLanguage(saved));
    } else {
      const detected = (navigator.language || '').toLowerCase();
      setLanguageState(normalizeLanguage(detected));
    }
  }, []);

  const setLanguage = (lang) => {
    const normalized = normalizeLanguage(lang);
    setLanguageState(normalized);
    localStorage.setItem('togee_language', normalized);
  };

  const toggleLanguage = () => {
    const nextLang = isFrenchLanguage(language) ? 'en' : 'fr-CA';
    setLanguage(nextLang);
  };

  const t = (key, replacements = {}) => {
    const dict = isFrenchLanguage(language) ? frDict : enDict;
    const template = dict[key] ?? enDict[key] ?? key;

    if (!replacements || typeof replacements !== 'object') {
      return template;
    }

    return Object.entries(replacements).reduce(
      (result, [name, value]) =>
        result.replace(
          new RegExp(`{{\\s*${escapeRegExp(name)}\\s*}}`, 'g'),
          value == null ? '' : String(value)
        ),
      template
    );
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
